import React from 'react';
import './BetaTestSection.css';
import { Button, UnderlinedText } from '../shared';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Beta Test CTA Section component
 * Displays call-to-action for joining the beta test
 *
 * @param {function} onNavigateToBetaTest - Callback to navigate to beta test page
 */
const BetaTestSection = ({ onNavigateToBetaTest }) => {
  const { t } = useLanguage();

  const handleBetaClick = () => {
    if (onNavigateToBetaTest) {
      onNavigateToBetaTest(true); // true = scroll to registration form
    }
  };

  return (
    <section className="beta-section" aria-labelledby="beta-heading">
      <div className="beta-section-container">
        <div className="beta-section-content">
          <div className="beta-section-text-block">
            {/* Title with two lines and highlighted text */}
            <h2 id="beta-heading" className="beta-section-title">
              {t('betaTest.line1Start')}
              <UnderlinedText textColor="#f6b707" showUnderline={false}>{t('betaTest.line1Highlight')}</UnderlinedText>
              {t('betaTest.line1End')}
              <br />
              {t('betaTest.line2Start')}
              <UnderlinedText textColor="#f6b707" showUnderline={false}>{t('betaTest.line2Highlight')}{t('betaTest.line2End')}</UnderlinedText>
            </h2>
          </div>

          {/* CTA Button */}
          <Button
            variant="primary"
            size="large"
            ariaLabel={t('a11y.betaButtonLabel')}
            onClick={handleBetaClick}
          >
            {t('betaTest.ctaButton')}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BetaTestSection;
